class MainDescription extends HTMLElement {
  constructor() {
    super();

    this.productJson = this.querySelector('[id^="ProductJSON-"]');
    this.readMore = this.querySelector('read-more');
    this.fullDescriptionHtml = JSON.parse(this.productJson.textContent);

    if (!this.readMore) return;

    this.readMore.addEventListener('click', this.handleClick.bind(this));
  }

  handleClick() {
    this.innerHTML = this.fullDescriptionHtml;
  }
};

customElements.define('main-description', MainDescription);

const normalizeCollectionCardForms = (root = document) => {
  root.querySelectorAll('.collection-card').forEach((card) => {
    const row = card.querySelector('.collection-card__inner-row');
    const formGroup = card.querySelector('.collection-card__product-form-group');

    if (row && formGroup && formGroup.parentElement !== row) {
      row.appendChild(formGroup);
    }
  });
};

normalizeCollectionCardForms();
document.addEventListener('DOMContentLoaded', () => normalizeCollectionCardForms());
document.addEventListener('shopify:section:load', (event) => {
  normalizeCollectionCardForms(event.target);
});

class MoreEmbedPlayers extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', this.handleClick.bind(this));
  }

  handleClick(event) {
    const parentNode = event.target.parentNode;
    const hiddenEmbedPlayers = parentNode.nextElementSibling;
    hiddenEmbedPlayers.classList.remove('visually-hidden');
    parentNode.style.display = 'none';
  }
};

customElements.define('more-embed-players', MoreEmbedPlayers);

class ShareProduct extends HTMLElement {
  constructor() {
    super();

    this.shareButton = this.querySelector('button');
    this.shareModal = this.querySelector('share-modal');
    this.successMessage = this.querySelector('[id^="ShareMessage"]');
    this.shareModalClose = this.shareModal.querySelector('share-modal-close');
    this.shareCopyButton = this.shareModal.querySelector('share-copy-button');
    this.urlInput = this.querySelector('input');

    this.isModalOpen = false;

    this.shareButton.addEventListener('click', this.handleToggleClick.bind(this));
    this.shareCopyButton.addEventListener('click', this.copyToClipboard.bind(this));
    this.shareModalClose.addEventListener('click', this.closeModal.bind(this));

    document.addEventListener('click', event => {
      const isClickedInside = this.contains(event.target);

      if (isClickedInside || !this.isModalOpen) return;

      this.closeModal();
    });
  }

  handleToggleClick() {
    if (this.isModalOpen) return this.closeModal();

    this.openModal();
  }

  openModal() {
    trapFocus(this.shareModal, this.shareModalClose);
    this.classList.add('modal-open');
    this.isModalOpen = true;
  }

  closeModal() {
    this.classList.remove('modal-open');
    removeTrapFocus();
    this.isModalOpen = false;

    setTimeout(() => {
      this.successMessage.classList.add('hidden');
      this.successMessage.textContent = '';
      this.shareModalClose.classList.add('hidden');
      this.shareCopyButton.classList.remove('hidden');
    }, 200);
  }

  copyToClipboard() {
    navigator.clipboard.writeText(this.urlInput.value).then(() => {
      this.successMessage.classList.remove('hidden');
      this.successMessage.textContent = window.accessibilityStrings.shareSuccess;
      this.shareCopyButton.classList.add('hidden');
      this.shareModalClose.classList.remove('hidden');
      this.shareModalClose.focus();
    });
  }
};

customElements.define('share-product', ShareProduct);

class ModalGalleryToggle extends HTMLElement {
  constructor() {
    super();

    this.toggle = this.querySelector('button');
    this.modal = this.querySelector('[id^="ModalGallery-"]');
    this.close = this.modal.querySelector('button');

    this.toggle.addEventListener('click', this.handleToggleClick.bind(this));
    this.close.addEventListener('click', this.handleCloseClick.bind(this));
  }

  handleToggleClick() {
    document.body.classList.add('modal-gallery-open');
    this.modal.classList.add('is-open');
  }

  handleCloseClick() {
    document.body.classList.remove('modal-gallery-open');
    this.modal.classList.remove('is-open');
  }
};

customElements.define('modal-gallery-toggle', ModalGalleryToggle);
